import { useState, useRef } from "react";
import * as Icons from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  onFocus?: () => void;
}

export function ChatInput({ onSendMessage, onFocus }: ChatInputProps) {
  const [message, setMessage] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedMessage = message.trim();
    if (trimmedMessage) {
      console.log('Sending message:', trimmedMessage);
      onSendMessage(trimmedMessage);
      setMessage("");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    console.log('Input changed:', e.target.value);
    setMessage(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    onFocus?.();
  };

  return (
    <form onSubmit={handleSubmit} className="flex space-x-2 min-w-0">
      <textarea
        ref={textareaRef}
        value={message}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        placeholder="Ask about tests & supplements..."
        rows={1}
        className="flex-1 min-h-[40px] max-h-[120px] p-2 md:p-3 text-sm md:text-base rounded-lg border border-gray-300 focus:outline-none focus:border-yellow-500 resize-none bg-white min-w-0 w-full"
        style={{ WebkitAppearance: 'none' }}
      />
      <Button 
        type="submit" 
        disabled={!message.trim()}
        className="flex-shrink-0 px-3 md:px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600/90 disabled:opacity-50 disabled:cursor-not-allowed text-sm md:text-base whitespace-nowrap"
      >
        Send
      </Button>
    </form>
  );
}